   <!-- Page Heading -->
   <div class="d-sm-flex align-items-center justify-content-between mb-4">
    <h1 class="h3 mb-0 text-gray-800">Editar una Ficha</h1>
  </div>
  <hr>


  <div class="row">
    <div class="col-md-4 order-md-2 mb-4">
      <h4 class="d-flex justify-content-between align-items-center mb-3">
        <span class="text-muted">Vista Previa DNI Actual</span>
        <button class="btn btn-danger btn-circle" *ngIf="ImagenTemp" (click)="quitarImagen()" >
          <i class="fas fa-times-circle"></i>
        </button>
      </h4>
      <div class="card" *ngIf="!ImagenTemp">
        <img [src]="dni | imagen:'dni'" alt="" class="img-fluid">
      </div>
      <div class="card" *ngIf="ImagenTemp">
        <img [src]="ImagenTemp" alt="" class="img-fluid">
      </div>
    </div>
    <div class="col-md-8 order-md-1">
      <h4 class="mb-3 text-gray-800">Datos Reales</h4>
      <form class="needs-validation"  [formGroup]="form">
        <div class="row">
          <div class="col-md-6 mb-3">
            <label for="firstName" class="text-gray-800">Nombre Completo</label>
            <input type="text" class="form-control" id="firstName" placeholder="Nombre Completo" formControlName="nombre" required>
            <div class="invalid-feedback">
              Valid first name is required.
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <label for="lastName" class="text-gray-800">DNI</label>
            <input type="text" class="form-control" formControlName="dni" id="lastName" placeholder="DNI "  required>
            <div class="invalid-feedback">
              Valid last name is required.
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mb-3">
            <label for="firstName" class="text-gray-800">Telefono Real</label>
            <input type="text" class="form-control" formControlName="telefono" placeholder="Telefono Real" required>
            <div class="invalid-feedback">
              Valid first name is required.
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <label for="lastName" class="text-gray-800">Fecha de Nacimiento</label>
            <input type="date" class="form-control " id="lastName" formControlName="fecha_nacimiento"  placeholder="Fecha Nacimiento" required>
            <div class="invalid-feedback">
              Valid last name is required.
            </div>
          </div>
        </div>
        <div class="mb-3">
          <label for="email" class="text-gray-800">Email</label>
          <input type="email" class="form-control" id="email" placeholder="you@example.com" formControlName="email">
          <div class="text-danger"  *ngIf="form.controls.email.invalid" >
            HACE FALTA ESTE CAMPO  O EMAIL TOMADO 
           </div>
        </div>
        <h5 class="mt-3">Cambiar DNI</h5>
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="inputGroupFileAddon01">Upload</span>
          </div>
          <div class="custom-file">
            <input type="file" class="custom-file-input" formControlName="file" aria-describedby="inputGroupFileAddon01"
              (change)="seleccionImagen($event.target.files[0])">
            <label class="custom-file-label" for="inputGroupFile01">Seleccione la Imagen</label>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="row flex-row-reverse mt-5">
    <div class="col-sm-2 mb-3">

      <button class="btn btn-success btn-icon-split mt-4"(click)="save()">
        <span class="icon text-white-50">
          <i class="far fa-save"></i>
        </span>
        <span class="text">
          Guardar Cambios
        </span>
      </button>

    </div>

  </div>

  <app-modal-loading [show]="modal_loading"></app-modal-loading>
